<template>
  <router-view />
</template>
<script setup>

import {useMenu} from "@/hook/useMenu"

import {onMounted} from "vue"

const {
  setOverlay
} = useMenu()

onMounted(()=>setOverlay(false))

</script>
